module.exports = __webpack_public_path__ + "img/racecourse-vaal-turf-inner.a9887460.svg";